import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import GalleryLightbox from '../components/GalleryLightbox';
import { imageUrl } from '../lib/images';

export default function ProductsPage() {
  const products = [
    {
      title: 'Glasfiber containere',
      subtitle: '300 - 400 - 600 - 800 - 1000 liter',
      desc: 'En stærk dansk håndoplagt glasfibercontainer fremstillet efter danske mål, tilpasset samtlige komprimatorbiler. Let håndtering med letløbende hjul og robust forstærkning på alle slidflader.',
      href: '/produkter/glasfiber-containere',
      image: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-4-hjulet-affaldsbeholder-glasfiber-container2-cropresize-625x625.webp',
      badge: '4-hjulet minicontainer',
      pdf: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-4-hjulet-glasfiber.pdf',
    },
    {
      title: 'Iglo & fancy',
      subtitle: 'Model joca & Fancy (700L - 2,5m³)',
      desc: 'Model joca er den velkendte iglo til genanvendelse af flasker og papir med mulighed for hærværkssikrede indstøbninger. Model Fancy tilbyder gennemtænkt brugervenlighed hvor pladsen er trang.',
      href: '/produkter/iglo-amp-fancy',
      image: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-joca-iglo-cropresize-412x619.webp',
      badge: 'Genbrugsigloer',
      pdf: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-iglo-joca.pdf',
    },
    {
      title: 'Batteribokse',
      subtitle: 'RB 10 og RB 30',
      desc: 'Batteriboks i samme design som igloen, fremstillet i glasfiber med kraftig gummiindkast. Tømningen er enkel gennem bundklap låst med nøgle. Kan monteres på iglo, stander eller væg.',
      href: '/produkter/batteribokse',
      image: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/batteriboks-resizewidth-625.webp',
      badge: '10 & 30 liter',
      pdf: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-batteriboks-rb.pdf',
    },
    {
      title: 'Sand-salt containere',
      subtitle: '200 - 400 - 600 - 800 liter',
      desc: 'Med vores sandcontainer er du klar til vinteren. Fremstillet i håndoplagt glasfiber, yderst slagfast og vedligeholdelsesfri. Leveres med låsebeslag, frontudtag og evt. indstøbt tekst.',
      href: '/produkter/sand-salt-containere',
      image: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-sand-salt-containere-cropresize-500x500.webp',
      badge: 'Vinterberedskab',
      pdf: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-produktblad-salt-sand-container.pdf',
    },
    {
      title: 'Pumpebrønde & indstøbningsbrønde',
      subtitle: 'Ø800 til Ø3000 mm',
      desc: 'Kemikalieresistente pumpebrønde med vinylesterbarriere til spildevand og regnvand, samt indstøbningsbrønde til renovering af udtjente betonbrønde.',
      href: '/rb-glasfiber/pumpebronde-amp-tanke',
      image: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/rb-glasfiber-pumpebroend-glasfiber-thumb1-cropresize-550x413.webp',
      badge: 'Forsyning & Afløb',
      pdf: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/brochure-pumpebroend.pdf',
    },
    {
      title: 'Dobbeltvæggede tanke & specialtanke',
      subtitle: 'Ekstra miljøsikring',
      desc: 'Tanke med dobbeltvæg forhindrer udsivning til naturen. Fremstilles som procestanke, doseringstanke eller trailermonterede tanke efter tegning.',
      href: '/rb-glasfiber/pumpebronde-amp-tanke',
      image: 'https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/dobbelt-tank-2019-scaled-e1581424144496-cropresize-550x413.webp',
      badge: 'Beholdere & Tanke',
      pdf: null,
    },
  ];

  return (
    <>
      <SeoHead
        title="Produkter og løsninger - RB Glasfiber A/S"
        description="Oversigt over standard produkter og løsninger i glasfiber fra RB Glasfiber A/S: containere, igloer, batteribokse, sand-salt containere og pumpebrønde."
        canonical="https://www.rb-glasfiber.dk/produkter"
        ogImage="https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-4-hjulet-affaldsbeholder-glasfiber-container2-cropresize-625x625.webp"
      />

      {/* Hero Header */}
      <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 bg-slate-950 text-white overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 z-0">
          <img
            src={imageUrl('https://assets.auxodev.dk/assets/9692fb57-52ae-41f1-9d47-5179b8f3a973/joca-4-hjulet-affaldsbeholder-glasfiber-container2-cropresize-625x625.webp', 'width=1600,quality=80,format=auto')}
            alt="Produkter & løsninger"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1e9457]/20 border border-[#1e9457]/40 text-[#22c55e] text-xs font-bold uppercase tracking-widest mb-4">
              <i className="fa-solid fa-boxes-stacked"></i>
              <span>Dansk fremstilling efter mål</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mb-6">
              Produkter & Løsninger
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              En stærk dansk håndoplagt glasfiberproduktion tilpasset danske mål og komprimatorbiler, samt specialløsninger til spildevand, industri og genbrug.
            </p>
          </div>
        </div>
      </section>

      {/* Product Grid */}
      <section className="py-16 bg-neutral-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-xl overflow-hidden border border-slate-200/90 shadow-sm hover:shadow-md transition-all flex flex-col group"
              >
                <div className="relative aspect-[4/3] bg-slate-950 overflow-hidden">
                  <img
                    src={imageUrl(item.image, 'width=600,quality=85,format=auto')}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded bg-slate-950/80 text-white text-[11px] font-bold uppercase tracking-wider">
                    {item.badge}
                  </div>
                </div>

                <div className="p-6 flex-1 flex flex-col justify-between space-y-4">
                  <div className="space-y-2">
                    <div className="text-xs font-bold text-[#1e9457] uppercase tracking-wide">
                      {item.subtitle}
                    </div>
                    <h2 className="text-xl font-bold text-slate-900 group-hover:text-[#1e9457] transition-colors">
                      {item.title}
                    </h2>
                    <p className="text-slate-600 text-sm leading-relaxed">
                      {item.desc}
                    </p>
                  </div>

                  <div className="pt-4 border-t border-slate-100 flex items-center justify-between gap-4">
                    <Link
                      to={item.href}
                      className="inline-flex items-center gap-2 text-sm font-bold text-[#1e9457] hover:text-[#15703f] transition-colors"
                    >
                      <span>Læs mere</span>
                      <i className="fa-solid fa-arrow-right text-xs"></i>
                    </Link>

                    {item.pdf && (
                      <a
                        href={item.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-slate-900 transition-colors"
                        title="Download datablad (PDF)"
                      >
                        <i className="fa-solid fa-file-pdf text-[#1e9457]"></i>
                        <span>Datablad</span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Lightbox Gallery */}
          <div className="pt-16 mt-16 border-t border-slate-200">
            <GalleryLightbox
              gallerySlug="standardprodukter"
              title="Fotogalleri: Standard produkter"
              description="Se billeder af containere, igloer, monterede batteribokse og sand-salt containere."
              columns={3}
            />
          </div>
        </div>
      </section>
    </>
  );
}
